/**
 * 업로드 진행률 오버레이. 업로드 중 "업로딩 n%"를 표시한다.
 * editor 는 showProgress(0)로 시작, hideProgress()로 종료한다.
 */
export function createUploadOverlay(L) {
  const overlay = document.createElement('div');
  overlay.className = 'lumir-upload-overlay';
  overlay.style.display = 'none';

  function showProgress(p) {
    overlay.style.display = 'flex';
    overlay.textContent =
      typeof p === 'number'
        ? `${L.upload.uploading} ${Math.round(p)}%`
        : L.upload.uploading;
  }
  function hideProgress() {
    overlay.style.display = 'none';
  }
  function destroy() {
    if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
  }

  return { overlayEl: overlay, showProgress, hideProgress, destroy };
}
